'use client'

import React, { useState } from 'react'
import { Theme, useMediaQuery } from '@mui/material'
import { Utils } from '@/lib/utils'
import { GTM_EVENT } from '@/interfaces/gtm'
import { RegistrantController } from '@/controllers'
import { useGtm, useNotification } from '@/hooks'
import { Content, MobileHeader, NotificationType } from '@/components/ui'
import { MessageType } from '@/interfaces/socket'
import { SendingLinkResultBlock } from '@/components/registrant/SendingLinkResultBlock'
import { MainContent } from '@/components/registrant/Registrant.styled'
import RegistrationForm, { FormValues } from '@/components/registrant/RegistrationForm'
import { useRegistrantSocket } from '@/components/registrant/useRegistrantSocket'
import { StorageFactory } from '@/services'
import { StorageType } from '@/interfaces/storage'

const RegistrantRegistration: React.FC = () => {
  const [isAuthLinkSent, setAuthLinkSent] = useState<boolean>(false)
  const [inProgress, setInProgress] = useState<boolean>(false)
  const { openNotification } = useNotification()
  const { sendDataToGTM } = useGtm()
  const { initSocketConnection, sendMessage } = useRegistrantSocket(MessageType.REGISTRATION)
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'))

  const sendSocketMessage = (phone: string, orgId: string) => {
    sendMessage({ phone, orgId })
  }

  const sendAuthLink = async ({ phone, ...values }: FormValues) => {
    const data = {
      ...values,
      phone: Utils.formatPhoneNumber(phone),
    }

    setInProgress(true)
    try {
      const {
        result: [error],
      } = await RegistrantController.sendAuthLink(data)

      if (error) {
        openNotification(error, NotificationType.ERROR)
        return
      }

      setAuthLinkSent(true)
      initSocketConnection(() => sendSocketMessage(data.phone, String(data.organizationMidasId)))
      sendSocketMessage(data.phone, String(data.organizationMidasId))
      sendDataToGTM({ event: GTM_EVENT.REG_AUTH_LINK })
      sendDataToGTM({ event: GTM_EVENT.REG_WAITING_PAGE })
    } finally {
      setInProgress(false)
    }
  }

  return (
    <Content sx={{ height: '100%', pt: isMobile ? 0 : 6, px: isMobile ? 0 : 4 }}>
      {isMobile && <MobileHeader logoSize={{ width: 244, height: 53 }} bgSize={{ height: 170, top: -20 }} />}
      <MainContent>
        {!isAuthLinkSent ? (
          <RegistrationForm onSubmit={sendAuthLink} inProgress={inProgress} />
        ) : (
          <SendingLinkResultBlock onClose={() => setAuthLinkSent(false)} />
        )}
      </MainContent>
    </Content>
  )
}

export default RegistrantRegistration
